import React, { useState } from "react";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import ConfirmModal from "../common/ConfirmModal";
import { removeSubPromoter, removeBusinessAssistant, blockKickParticipant } from "../../services/eventDetailService";

/**
 * Confirm + execute a removal/block action, mirroring mobile's
 * remove-bottom-sheet/index.js (condensed into a single confirm dialog per
 * action instead of a bottom-sheet action list, since the web already shows
 * a "Remove" button per row inline).
 *
 * @param target {{type: 'subPromoter'|'businessAssistant'|'participant', id, chatRoomId, name}}
 */
const RemoveParticipantModal = ({ target, onClose, onRemoved }) => {
  const { t } = useTranslation(["eventDetails", "common"]);
  const [loading, setLoading] = useState(false);
  if (!target) return null;

  const labels = {
    subPromoter: { title: t("removeParticipantModal.subPromoter.title"), message: t("removeParticipantModal.subPromoter.message", { name: target.name }) },
    businessAssistant: { title: t("removeParticipantModal.businessAssistant.title"), message: t("removeParticipantModal.businessAssistant.message", { name: target.name }) },
    participant: { title: t("removeParticipantModal.participant.title"), message: t("removeParticipantModal.participant.message", { name: target.name }) },
  };
  const { title, message } = labels[target.type] || labels.participant;

  const handleConfirm = async () => {
    setLoading(true);
    try {
      if (target.type === "subPromoter") {
        await removeSubPromoter(target.chatRoomId, target.id);
      } else if (target.type === "businessAssistant") {
        await removeBusinessAssistant(target.id);
      } else {
        await blockKickParticipant(target.chatRoomId, target.id, { kick: false, block: true });
      }
      toast.success(t("removeParticipantModal.removed", { name: target.name }));
      onRemoved();
    } catch (err) {
      toast.error(err.response?.data?.Message || t("removeParticipantModal.actionError"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <ConfirmModal
      title={title}
      message={message}
      confirmText={t("common:actions.remove")}
      danger
      loading={loading}
      onConfirm={handleConfirm}
      onCancel={() => !loading && onClose()}
    />
  );
};

export default RemoveParticipantModal;
